export const events = [
  {
    id: 'autumn-gala',
    date: 'Oct 15, 2026',
    title: 'The Centenary Autumn Gala',
    time: '19:00',
    loc: 'The Grand Ballroom',
    desc: 'Join us for our most prestigious event of the year, featuring a five-course tasting menu and live jazz.',
    longDesc:
      "The Centenary Autumn Gala is the highlight of the Club's social calendar. This black-tie event celebrates our rich history with an evening of unparalleled elegance. Guests will be welcomed with a Champagne reception on the terrace, followed by a spectacular five-course tasting menu curated by our Executive Chef, paired with exceptional vintages from our cellar. The evening will conclude with dancing to a renowned 12-piece jazz orchestra.",
    image:
      'https://images.unsplash.com/photo-1519671482749-fd09be7ccebf?ixlib=rb-4.0.3&auto=format&fit=crop&w=1170&q=80',
    images: [
      'https://images.unsplash.com/photo-1519671482749-fd09be7ccebf?ixlib=rb-4.0.3&auto=format&fit=crop&w=1170&q=80',
    ],
    keyDetails: [
      { label: 'Date & Time', value: 'October 15, 2026 at 19:00' },
      { label: 'Location', value: 'The Grand Ballroom' },
      { label: 'Dress Code', value: 'Black Tie' },
      { label: 'Tickets', value: '£150 per person' },
    ],
  },
  {
    id: 'wine-tasting',
    date: 'Oct 22, 2026',
    title: 'Wine Tasting: Bordeaux Masterclass',
    time: '18:30',
    loc: 'The Cellar',
    desc: 'An exclusive tasting of rare Bordeaux vintages led by our head sommelier.',
    longDesc:
      "Join our Head Sommelier for an intimate and educational journey through the prestigious vineyards of Bordeaux. This masterclass will feature a guided tasting of six exceptional, rare vintages sourced directly from the Club's private reserves. The tasting will be accompanied by a selection of artisanal cheeses and charcuterie designed to complement the complex flavor profiles of the wines.",
    image:
      'https://images.unsplash.com/photo-1506377247377-2a5b3b417ebb?ixlib=rb-4.0.3&auto=format&fit=crop&w=1170&q=80',
    images: [
      'https://images.unsplash.com/photo-1506377247377-2a5b3b417ebb?ixlib=rb-4.0.3&auto=format&fit=crop&w=1170&q=80',
    ],
    keyDetails: [
      { label: 'Date & Time', value: 'October 22, 2026 at 18:30' },
      { label: 'Location', value: 'The Cellar' },
      { label: 'Dress Code', value: 'Smart Casual' },
      { label: 'Tickets', value: '£85 per person (Limited to 20)' },
    ],
  },
  {
    id: 'golf-tournament',
    date: 'Nov 05, 2026',
    title: 'Members Autumn Golf Tournament',
    time: '08:00',
    loc: 'Championship Course',
    desc: 'Our annual autumn tournament followed by a prize-giving luncheon.',
    longDesc:
      'The Members Autumn Golf Tournament is a beloved club tradition. The format is an 18-hole Stableford competition, open to members of all handicap levels. The day begins with a light breakfast in the clubhouse, followed by a shotgun start at 09:00. After the round, participants will gather in the Oak Lounge for a hearty carvery luncheon and the presentation of trophies and prizes.',
    image:
      'https://images.unsplash.com/photo-1587222318667-31212ce2828d?ixlib=rb-4.0.3&auto=format&fit=crop&w=1170&q=80',
    images: [
      'https://images.unsplash.com/photo-1587222318667-31212ce2828d?ixlib=rb-4.0.3&auto=format&fit=crop&w=1170&q=80',
    ],
    keyDetails: [
      { label: 'Date & Time', value: 'November 05, 2026 at 08:00' },
      { label: 'Location', value: 'Championship Course' },
      { label: 'Format', value: '18-Hole Stableford' },
      { label: 'Entry Fee', value: '£45 (Includes Lunch)' },
    ],
  },
  {
    id: 'guest-speaker',
    date: 'Nov 12, 2026',
    title: 'Guest Speaker Series',
    time: '19:00',
    loc: 'Kakatiya Hall',
    desc: 'A captivating evening of discussion and debate with renowned authors and thought leaders.',
    longDesc:
      'Andhra Social & Cultural Association is proud to continue its tradition of intellectual discourse with our Guest Speaker Series. This month, we welcome a distinguished historian and best-selling author to discuss their latest work on 20th-century diplomacy. The evening will begin with a 45-minute presentation, followed by an interactive Q&A session with the audience. A book signing and drinks reception will conclude the event.',
    image:
      'https://images.unsplash.com/photo-1475721025505-231223111040?ixlib=rb-4.0.3&auto=format&fit=crop&w=1170&q=80',
    images: [
      'https://images.unsplash.com/photo-1475721025505-231223111040?ixlib=rb-4.0.3&auto=format&fit=crop&w=1170&q=80',
    ],
    keyDetails: [
      { label: 'Date & Time', value: 'November 12, 2026 at 19:00' },
      { label: 'Location', value: 'Kakatiya Hall' },
      { label: 'Dress Code', value: 'Smart Casual' },
      { label: 'Tickets', value: 'Complimentary for Members' },
    ],
  },
]

export const getEventBySlug = (slug: string) =>
  events.find((e) => e.id === slug)
